define('directives/common/verify-code/verify-code.directive',['app', 'mainCons'], function (app, mainCons) {
    app.directive('verifyCode', ['$q', '$filter', '$timeout', 'OpenUp', function ($q, $filter, $timeout, OpenUp) {
        var timeout;
        return {
            restrict: 'E',
            scope: {
                verPhone: "=",
                verCode: "=",
                verSuccess:"=",
                verDirty:"=",
                resetVer:"="
            },
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/common/verify-code/verify-code.template.html',
            link: function ($scope, element, attrs, ngModelCtrl) {
                $scope.isCountSecond = false;
                $scope.isVerCodeBtn = true;
                var timer;
                var timerTemp;
                var repeatCount = 0;
                // 短信验证码有效时间
                $scope.timeoutCount = angular.copy(systemParaConf.user.phoneCodeTimeout);

                $scope.verPhone = $scope.verPhone;
                $scope.verType = 1;
                $scope.$watch('verPhone', function () {
                    reset();
                });

                $scope.$watch('resetVer', function () {
                    reset();
                    $scope.resetVer = false;
                });

                function reset() {
                    $scope.verCode = "";
                    $scope.verFailed = false;
                    $scope.isVerDisabled =false;
                    $scope.verSuccess = false;
                    $scope.isCountSecond = false;
                    $scope.isVerCodeBtn = true;
                    repeatCount = 0;
                }

                $scope.$watch('verDirty', function () {
                    if($scope.verDirty){
                        $scope.verifyForm.verifyCode.$setDirty();
                    }
                });

                $scope.$watch('verCode', function (newValue, oldValue) {
                    $scope.verFailed = false;
                    $scope.verSuccess = false;
                    $scope.verFailedOfError = false;
                    $scope.verFailedOfTimes = false;
                    $scope.isVerDisabled =false;
                    if (!newValue && !oldValue) {
                        return;
                    }
                    if (newValue && $scope.verifyForm.$valid && newValue.length == 6) {
                        OpenUp.verify({ req:{
                            account: ($scope.verPhone.replace("+", "00")).substring(0,4)=="0086" ?($scope.verPhone.replace("+", "00")):"0086"+$scope.verPhone.replace("+", "00"),
                            authCode: newValue
                        }
                        },true).then(function (res) {
                            if (res && res.userID) {
                                $scope.verSuccess = true;
                                $scope.isVerDisabled =true;
                                timerTemp = $timeout(function() {
                                    $timeout.cancel(timerTemp);
                                    $scope.verCode = "";
                                    $scope.verSuccess = false;
                                    $scope.isCountSecond = false;
                                    $scope.isVerCodeBtn = true;
                                    $scope.verFailed = false;
                                    $scope.isVerDisabled =false;
                                }, 300000);
                            }
                            else if (res && (res.NSP_STATUS =='90320004' || res.NSP_STATUS =='90320005')) {
                                $scope.verSuccess = false;
                                $scope.verFailed = true;
                                $scope.verFailedOfTimes = true;
                            } else {
                                $scope.verSuccess = false;
                                $scope.verFailed = true;
                                $scope.verFailedOfError = true;
                            }
                        }).catch(function (res) {
                            if (res && (res.NSP_STATUS =='90320004' || res.NSP_STATUS =='90320005')) {
                                $scope.verFailedOfTimes = true;
                            } else {
                                $scope.verFailedOfError = true;
                            }
                            $scope.verFailed = true;
                            $scope.verSuccess = false;
                        });
                    }
                });

                $scope.getVerCode = function () {
                    var defer = $q.defer();
                    getSMSVerCode($scope.verPhone).then(function (data) {
                        if (data.userID) {
                            $scope.timeoutCount = systemParaConf.user.phoneCodeTimeout;
                            // 改变样式为倒计时
                            $scope.isCountSecond = true;
                            $scope.isVerCodeBtn = false;
                            // 计时开始
                            startPhoneCodeTimer();
                            defer.resolve(data);
                        }else{
                            defer.resolve(data);
                        }
                    });
                    return defer.promise;
                };

                $scope.checkVerCode=function () {
                    if($scope.verCode && $scope.verCode.length !=0 && $scope.verCode.length<6){
                        $scope.verFailed = true;
                        $scope.verFailedOfError = true;
                    }
                };

                //获取验证码并设置倒计时
                function getSMSVerCode(phone) {
                    var defer = $q.defer();
                    $timeout.cancel(timer);
                    OpenUp.getSMSAuthCode({req:{
                        mobilePhone: (phone.replace("+", "00")).substring(0,4)=="0086" ?(phone.replace("+", "00")):"0086"+phone.replace("+", "00"),
                            languageCode:'zh-CN',
                            smsReqType: 3,
                            repeatCount:repeatCount
                    }}).then(function (res) {
                        defer.resolve(res);
                    }).catch(function (res) {
                        defer.resolve(res);
                    });
                    return defer.promise;
                }

                // 计时器倒计时
                function startPhoneCodeTimer() {
                    if ($scope.timeoutCount <= 0) {
                        if(repeatCount <100){
                            repeatCount ++;
                        }else{
                            repeatCount =0;
                        }
                        $scope.isCountSecond = false;
                        $scope.isVerCodeBtn = true;
                    }
                    else {
                        // 显示当前计时
                        $scope.timeoutCount--;
                        // 递归计时
                        timer = $timeout(startPhoneCodeTimer, 1000);
                    }
                }
            }
        }
    }]);
});
